import { FC } from "react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/general/selectedSubjectDisplay.module.css";

interface Props {
  subjectName?: string;
  onReset: () => void;
  customLabel?: string;
  wrapperClassName?: string;
  containerClassName?: string;
  loadingLabel?: string;
  resetLabel?: string;
}

const SelectedSubjectDisplay: FC<Props> = ({
  subjectName,
  onReset,
  customLabel,
  wrapperClassName,
  containerClassName,
  loadingLabel,
  resetLabel,
}) => {
  const { t } = useTranslation();
  const resolvedResetLabel = resetLabel ?? t("reset");
  const resolvedLoadingLabel = loadingLabel ?? t("loading");

  return (
    <div className={wrapperClassName}>
      <div>{customLabel ?? t("selected_subject")}</div>
      <div
        className={
          containerClassName
            ? `${styles.container} ${containerClassName}`
            : styles.container
        }
      >
        <span className={styles.text}>
          {subjectName ? subjectName : resolvedLoadingLabel}
        </span>
        <span className={styles.resetButtonWrapper}>
          <Tooltip title={resolvedResetLabel} placement="top" arrow>
            <GenericButton
              variant="icon"
              color="tertiary"
              onClick={onReset}
              aria-label={resolvedResetLabel}
            >
              <RestartAltIcon />
            </GenericButton>
          </Tooltip>
        </span>
      </div>
    </div>
  );
};

export default SelectedSubjectDisplay;
